module.exports = __webpack_public_path__ + "static/media/riskcase5.f9561336.png";